import { render, staticRenderFns } from "./AddPurchasesPaymentComponent.vue?vue&type=template&id=15918e46"
import script from "./AddPurchasesPaymentComponent.vue?vue&type=script&lang=js"
export * from "./AddPurchasesPaymentComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports